module.exports = __webpack_public_path__ + "fonts/la-regular-400.87dab6ff.ttf";